// Numeric activity IDs from Valve source-sdk-2013 src/game/shared/ai_activity.h.
// PlayerAnimEvent data carries activities, not model-local sequence numbers.
export const activityNames = new Map([
    [1, "ACT_IDLE"],
    [20, "ACT_DIESIMPLE"],
    [21, "ACT_DIEBACKWARD"],
    [22, "ACT_DIEFORWARD"],
    [23, "ACT_DIEVIOLENT"],
    [24, "ACT_DIERAGDOLL"],
    [112, "ACT_DIE_HEADSHOT"],
    [113, "ACT_DIE_CHESTSHOT"],
    [114, "ACT_DIE_GUTSHOT"],
    [115, "ACT_DIE_BACKSHOT"],
    [400, "ACT_DIE_BARNACLE_SWALLOW"],
    [406, "ACT_DIE_FRONTSIDE"],
    [407, "ACT_DIE_RIGHTSIDE"],
    [408, "ACT_DIE_BACKSIDE"],
    [409, "ACT_DIE_LEFTSIDE"],
    [1066, "ACT_MP_STAND_IDLE"],
    [1067, "ACT_MP_CROUCH_IDLE"],
    [1068, "ACT_MP_CROUCH_DEPLOYED_IDLE"],
    [1069, "ACT_MP_CROUCH_DEPLOYED"],
    [1070, "ACT_MP_CROUCHWALK_DEPLOYED"],
    [1071, "ACT_MP_DEPLOYED_IDLE"],
    [1072, "ACT_MP_RUN"],
    [1073, "ACT_MP_WALK"],
    [1074, "ACT_MP_AIRWALK"],
    [1075, "ACT_MP_CROUCHWALK"],
    [1076, "ACT_MP_SPRINT"],
    [1077, "ACT_MP_JUMP"],
    [1078, "ACT_MP_JUMP_START"],
    [1079, "ACT_MP_JUMP_FLOAT"],
    [1080, "ACT_MP_JUMP_LAND"],
    [1081, "ACT_MP_DOUBLEJUMP"],
    [1082, "ACT_MP_SWIM"],
    [1083, "ACT_MP_DEPLOYED"],
    [1084, "ACT_MP_SWIM_DEPLOYED"],
    [1085, "ACT_MP_VCD"],
    [1086, "ACT_MP_ATTACK_STAND_PRIMARYFIRE"],
    [1087, "ACT_MP_ATTACK_STAND_PRIMARYFIRE_DEPLOYED"],
    [1088, "ACT_MP_ATTACK_STAND_SECONDARYFIRE"],
    [1089, "ACT_MP_ATTACK_STAND_GRENADE"],
    [1090, "ACT_MP_ATTACK_CROUCH_PRIMARYFIRE"],
    [1091, "ACT_MP_ATTACK_CROUCH_PRIMARYFIRE_DEPLOYED"],
    [1092, "ACT_MP_ATTACK_CROUCH_SECONDARYFIRE"],
    [1093, "ACT_MP_ATTACK_CROUCH_GRENADE"],
    [1094, "ACT_MP_ATTACK_SWIM_PRIMARYFIRE"],
    [1095, "ACT_MP_ATTACK_SWIM_SECONDARYFIRE"],
    [1096, "ACT_MP_ATTACK_SWIM_GRENADE"],
    [1097, "ACT_MP_ATTACK_AIRWALK_PRIMARYFIRE"],
    [1098, "ACT_MP_ATTACK_AIRWALK_SECONDARYFIRE"],
    [1099, "ACT_MP_ATTACK_AIRWALK_GRENADE"],
    [1100, "ACT_MP_RELOAD_STAND"],
    [1101, "ACT_MP_RELOAD_STAND_LOOP"],
    [1102, "ACT_MP_RELOAD_STAND_END"],
    [1103, "ACT_MP_RELOAD_CROUCH"],
    [1104, "ACT_MP_RELOAD_CROUCH_LOOP"],
    [1105, "ACT_MP_RELOAD_CROUCH_END"],
    [1106, "ACT_MP_RELOAD_SWIM"],
    [1107, "ACT_MP_RELOAD_SWIM_LOOP"],
    [1108, "ACT_MP_RELOAD_SWIM_END"],
    [1109, "ACT_MP_RELOAD_AIRWALK"],
    [1110, "ACT_MP_RELOAD_AIRWALK_LOOP"],
    [1111, "ACT_MP_RELOAD_AIRWALK_END"],
    [1112, "ACT_MP_ATTACK_STAND_PREFIRE"],
    [1113, "ACT_MP_ATTACK_STAND_POSTFIRE"],
    [1114, "ACT_MP_ATTACK_STAND_STARTFIRE"],
    [1115, "ACT_MP_ATTACK_CROUCH_PREFIRE"],
    [1116, "ACT_MP_ATTACK_CROUCH_POSTFIRE"],
    [1117, "ACT_MP_ATTACK_SWIM_PREFIRE"],
    [1118, "ACT_MP_ATTACK_SWIM_POSTFIRE"],
    [1119, "ACT_MP_STAND_PRIMARY"],
    [1120, "ACT_MP_CROUCH_PRIMARY"],
    [1121, "ACT_MP_RUN_PRIMARY"],
    [1122, "ACT_MP_WALK_PRIMARY"],
    [1123, "ACT_MP_AIRWALK_PRIMARY"],
    [1124, "ACT_MP_CROUCHWALK_PRIMARY"],
    [1125, "ACT_MP_JUMP_PRIMARY"],
    [1126, "ACT_MP_JUMP_START_PRIMARY"],
    [1127, "ACT_MP_JUMP_FLOAT_PRIMARY"],
    [1128, "ACT_MP_JUMP_LAND_PRIMARY"],
    [1129, "ACT_MP_SWIM_PRIMARY"],
    [1130, "ACT_MP_DEPLOYED_PRIMARY"],
    [1131, "ACT_MP_SWIM_DEPLOYED_PRIMARY"],
    [1132, "ACT_MP_CROUCHWALK_DEPLOYED_PRIMARY"],
    [1133, "ACT_MP_CROUCH_DEPLOYED_IDLE_PRIMARY"],
    [1134, "ACT_MP_ATTACK_STAND_PRIMARY"],
    [1135, "ACT_MP_ATTACK_STAND_PRIMARY_DEPLOYED"],
    [1136, "ACT_MP_ATTACK_CROUCH_PRIMARY"],
    [1137, "ACT_MP_ATTACK_CROUCH_PRIMARY_DEPLOYED"],
    [1138, "ACT_MP_ATTACK_SWIM_PRIMARY"],
    [1139, "ACT_MP_ATTACK_AIRWALK_PRIMARY"],
    [1140, "ACT_MP_RELOAD_STAND_PRIMARY"],
    [1141, "ACT_MP_RELOAD_STAND_PRIMARY_LOOP"],
    [1142, "ACT_MP_RELOAD_STAND_PRIMARY_END"],
    [1143, "ACT_MP_RELOAD_CROUCH_PRIMARY"],
    [1144, "ACT_MP_RELOAD_CROUCH_PRIMARY_LOOP"],
    [1145, "ACT_MP_RELOAD_CROUCH_PRIMARY_END"],
    [1146, "ACT_MP_RELOAD_SWIM_PRIMARY"],
    [1147, "ACT_MP_RELOAD_SWIM_PRIMARY_LOOP"],
    [1148, "ACT_MP_RELOAD_SWIM_PRIMARY_END"],
    [1149, "ACT_MP_RELOAD_AIRWALK_PRIMARY"],
    [1150, "ACT_MP_RELOAD_AIRWALK_PRIMARY_LOOP"],
    [1151, "ACT_MP_RELOAD_AIRWALK_PRIMARY_END"],
    [1152, "ACT_MP_RELOAD_STAND_PRIMARY_2"],
    [1153, "ACT_MP_RELOAD_STAND_PRIMARY_LOOP_2"],
    [1154, "ACT_MP_RELOAD_STAND_PRIMARY_END_2"],
    [1155, "ACT_MP_RELOAD_CROUCH_PRIMARY_2"],
    [1156, "ACT_MP_RELOAD_CROUCH_PRIMARY_LOOP_2"],
    [1157, "ACT_MP_RELOAD_CROUCH_PRIMARY_END_2"],
    [1158, "ACT_MP_RELOAD_SWIM_PRIMARY_2"],
    [1159, "ACT_MP_RELOAD_SWIM_PRIMARY_LOOP_2"],
    [1160, "ACT_MP_RELOAD_SWIM_PRIMARY_END_2"],
    [1161, "ACT_MP_RELOAD_AIRWALK_PRIMARY_2"],
    [1162, "ACT_MP_RELOAD_AIRWALK_PRIMARY_LOOP_2"],
    [1163, "ACT_MP_RELOAD_AIRWALK_PRIMARY_END_2"],
    [1164, "ACT_MP_ATTACK_STAND_PRIMARY_ALT"],
    [1165, "ACT_MP_ATTACK_CROUCH_PRIMARY_ALT"],
    [1166, "ACT_MP_ATTACK_SWIM_PRIMARY_ALT"],
    [1167, "ACT_MP_RELOAD_STAND_PRIMARY_ALT"],
    [1168, "ACT_MP_RELOAD_CROUCH_PRIMARY_ALT"],
    [1169, "ACT_MP_RELOAD_AIRWALK_PRIMARY_ALT"],
    [1170, "ACT_MP_RELOAD_STAND_PRIMARY_LOOP_ALT"],
    [1171, "ACT_MP_RELOAD_CROUCH_PRIMARY_LOOP_ALT"],
    [1172, "ACT_MP_RELOAD_AIRWALK_PRIMARY_LOOP_ALT"],
    [1173, "ACT_MP_RELOAD_STAND_PRIMARY_END_ALT"],
    [1174, "ACT_MP_RELOAD_CROUCH_PRIMARY_END_ALT"],
    [1175, "ACT_MP_RELOAD_AIRWALK_PRIMARY_END_ALT"],
    [1176, "ACT_MP_RELOAD_SWIM_PRIMARY_ALT"],
    [1177, "ACT_MP_ATTACK_STAND_PRIMARY_SUPER"],
    [1178, "ACT_MP_ATTACK_CROUCH_PRIMARY_SUPER"],
    [1179, "ACT_MP_ATTACK_SWIM_PRIMARY_SUPER"],
    [1180, "ACT_MP_ATTACK_STAND_GRENADE_PRIMARY"],
    [1181, "ACT_MP_ATTACK_CROUCH_GRENADE_PRIMARY"],
    [1182, "ACT_MP_ATTACK_SWIM_GRENADE_PRIMARY"],
    [1183, "ACT_MP_ATTACK_AIRWALK_GRENADE_PRIMARY"],
    [1184, "ACT_MP_STAND_SECONDARY"],
    [1185, "ACT_MP_CROUCH_SECONDARY"],
    [1186, "ACT_MP_RUN_SECONDARY"],
    [1187, "ACT_MP_WALK_SECONDARY"],
    [1188, "ACT_MP_AIRWALK_SECONDARY"],
    [1189, "ACT_MP_CROUCHWALK_SECONDARY"],
    [1190, "ACT_MP_JUMP_SECONDARY"],
    [1191, "ACT_MP_JUMP_START_SECONDARY"],
    [1192, "ACT_MP_JUMP_FLOAT_SECONDARY"],
    [1193, "ACT_MP_JUMP_LAND_SECONDARY"],
    [1194, "ACT_MP_SWIM_SECONDARY"],
    [1195, "ACT_MP_ATTACK_STAND_SECONDARY"],
    [1196, "ACT_MP_ATTACK_CROUCH_SECONDARY"],
    [1197, "ACT_MP_ATTACK_SWIM_SECONDARY"],
    [1198, "ACT_MP_ATTACK_AIRWALK_SECONDARY"],
    [1199, "ACT_MP_RELOAD_STAND_SECONDARY"],
    [1200, "ACT_MP_RELOAD_STAND_SECONDARY_LOOP"],
    [1201, "ACT_MP_RELOAD_STAND_SECONDARY_END"],
    [1202, "ACT_MP_RELOAD_CROUCH_SECONDARY"],
    [1203, "ACT_MP_RELOAD_CROUCH_SECONDARY_LOOP"],
    [1204, "ACT_MP_RELOAD_CROUCH_SECONDARY_END"],
    [1205, "ACT_MP_RELOAD_SWIM_SECONDARY"],
    [1206, "ACT_MP_RELOAD_SWIM_SECONDARY_LOOP"],
    [1207, "ACT_MP_RELOAD_SWIM_SECONDARY_END"],
    [1208, "ACT_MP_RELOAD_AIRWALK_SECONDARY"],
    [1209, "ACT_MP_RELOAD_AIRWALK_SECONDARY_LOOP"],
    [1210, "ACT_MP_RELOAD_AIRWALK_SECONDARY_END"],
    [1211, "ACT_MP_RELOAD_STAND_SECONDARY_2"],
    [1212, "ACT_MP_RELOAD_CROUCH_SECONDARY_2"],
    [1213, "ACT_MP_RELOAD_SWIM_SECONDARY_2"],
    [1214, "ACT_MP_RELOAD_AIRWALK_SECONDARY_2"],
    [1215, "ACT_MP_ATTACK_STAND_GRENADE_SECONDARY"],
    [1216, "ACT_MP_ATTACK_CROUCH_GRENADE_SECONDARY"],
    [1217, "ACT_MP_ATTACK_SWIM_GRENADE_SECONDARY"],
    [1218, "ACT_MP_ATTACK_AIRWALK_GRENADE_SECONDARY"],
    [1219, "ACT_MP_STAND_SECONDARY2"],
    [1220, "ACT_MP_CROUCH_SECONDARY2"],
    [1221, "ACT_MP_RUN_SECONDARY2"],
    [1222, "ACT_MP_WALK_SECONDARY2"],
    [1223, "ACT_MP_AIRWALK_SECONDARY2"],
    [1224, "ACT_MP_CROUCHWALK_SECONDARY2"],
    [1225, "ACT_MP_JUMP_SECONDARY2"],
    [1226, "ACT_MP_JUMP_START_SECONDARY2"],
    [1227, "ACT_MP_JUMP_FLOAT_SECONDARY2"],
    [1228, "ACT_MP_JUMP_LAND_SECONDARY2"],
    [1229, "ACT_MP_SWIM_SECONDARY2"],
    [1230, "ACT_MP_ATTACK_STAND_SECONDARY2"],
    [1231, "ACT_MP_ATTACK_CROUCH_SECONDARY2"],
    [1232, "ACT_MP_ATTACK_SWIM_SECONDARY2"],
    [1233, "ACT_MP_ATTACK_AIRWALK_SECONDARY2"],
    [1234, "ACT_MP_RELOAD_STAND_SECONDARY2"],
    [1235, "ACT_MP_RELOAD_STAND_SECONDARY2_LOOP"],
    [1236, "ACT_MP_RELOAD_STAND_SECONDARY2_END"],
    [1237, "ACT_MP_RELOAD_CROUCH_SECONDARY2"],
    [1238, "ACT_MP_RELOAD_CROUCH_SECONDARY2_LOOP"],
    [1239, "ACT_MP_RELOAD_CROUCH_SECONDARY2_END"],
    [1240, "ACT_MP_RELOAD_SWIM_SECONDARY2"],
    [1241, "ACT_MP_RELOAD_SWIM_SECONDARY2_LOOP"],
    [1242, "ACT_MP_RELOAD_SWIM_SECONDARY2_END"],
    [1243, "ACT_MP_RELOAD_AIRWALK_SECONDARY2"],
    [1244, "ACT_MP_RELOAD_AIRWALK_SECONDARY2_LOOP"],
    [1245, "ACT_MP_RELOAD_AIRWALK_SECONDARY2_END"],
    [1246, "ACT_MP_STAND_MELEE"],
    [1247, "ACT_MP_CROUCH_MELEE"],
    [1248, "ACT_MP_RUN_MELEE"],
    [1249, "ACT_MP_WALK_MELEE"],
    [1250, "ACT_MP_AIRWALK_MELEE"],
    [1251, "ACT_MP_CROUCHWALK_MELEE"],
    [1252, "ACT_MP_JUMP_MELEE"],
    [1253, "ACT_MP_JUMP_START_MELEE"],
    [1254, "ACT_MP_JUMP_FLOAT_MELEE"],
    [1255, "ACT_MP_JUMP_LAND_MELEE"],
    [1256, "ACT_MP_SWIM_MELEE"],
    [1257, "ACT_MP_ATTACK_STAND_MELEE"],
    [1258, "ACT_MP_ATTACK_STAND_MELEE_SECONDARY"],
    [1259, "ACT_MP_ATTACK_CROUCH_MELEE"],
    [1260, "ACT_MP_ATTACK_CROUCH_MELEE_SECONDARY"],
    [1261, "ACT_MP_ATTACK_SWIM_MELEE"],
    [1262, "ACT_MP_ATTACK_AIRWALK_MELEE"],
    [1263, "ACT_MP_ATTACK_STAND_GRENADE_MELEE"],
    [1264, "ACT_MP_ATTACK_CROUCH_GRENADE_MELEE"],
    [1265, "ACT_MP_ATTACK_SWIM_GRENADE_MELEE"],
    [1266, "ACT_MP_ATTACK_AIRWALK_GRENADE_MELEE"],
    [1267, "ACT_MP_STAND_ITEM1"],
    [1268, "ACT_MP_CROUCH_ITEM1"],
    [1269, "ACT_MP_RUN_ITEM1"],
    [1270, "ACT_MP_WALK_ITEM1"],
    [1271, "ACT_MP_AIRWALK_ITEM1"],
    [1272, "ACT_MP_CROUCHWALK_ITEM1"],
    [1273, "ACT_MP_JUMP_ITEM1"],
    [1274, "ACT_MP_JUMP_START_ITEM1"],
    [1275, "ACT_MP_JUMP_FLOAT_ITEM1"],
    [1276, "ACT_MP_JUMP_LAND_ITEM1"],
    [1277, "ACT_MP_SWIM_ITEM1"],
    [1278, "ACT_MP_ATTACK_STAND_ITEM1"],
    [1279, "ACT_MP_ATTACK_STAND_ITEM1_SECONDARY"],
    [1280, "ACT_MP_ATTACK_CROUCH_ITEM1"],
    [1281, "ACT_MP_ATTACK_CROUCH_ITEM1_SECONDARY"],
    [1282, "ACT_MP_ATTACK_SWIM_ITEM1"],
    [1283, "ACT_MP_ATTACK_AIRWALK_ITEM1"],
    [1284, "ACT_MP_DEPLOYED_ITEM1"],
    [1285, "ACT_MP_DEPLOYED_IDLE_ITEM1"],
    [1286, "ACT_MP_CROUCHWALK_DEPLOYED_ITEM1"],
    [1287, "ACT_MP_CROUCH_DEPLOYED_IDLE_ITEM1"],
    [1288, "ACT_MP_ATTACK_STAND_PRIMARY_DEPLOYED_ITEM1"],
    [1289, "ACT_MP_ATTACK_CROUCH_PRIMARY_DEPLOYED_ITEM1"],
    [1290, "ACT_MP_STAND_ITEM2"],
    [1291, "ACT_MP_CROUCH_ITEM2"],
    [1292, "ACT_MP_RUN_ITEM2"],
    [1293, "ACT_MP_WALK_ITEM2"],
    [1294, "ACT_MP_AIRWALK_ITEM2"],
    [1295, "ACT_MP_CROUCHWALK_ITEM2"],
    [1296, "ACT_MP_JUMP_ITEM2"],
    [1297, "ACT_MP_JUMP_START_ITEM2"],
    [1298, "ACT_MP_JUMP_FLOAT_ITEM2"],
    [1299, "ACT_MP_JUMP_LAND_ITEM2"],
    [1300, "ACT_MP_SWIM_ITEM2"],
    [1301, "ACT_MP_ATTACK_STAND_ITEM2"],
    [1302, "ACT_MP_ATTACK_STAND_ITEM2_SECONDARY"],
    [1303, "ACT_MP_ATTACK_CROUCH_ITEM2"],
    [1304, "ACT_MP_ATTACK_CROUCH_ITEM2_SECONDARY"],
    [1305, "ACT_MP_ATTACK_SWIM_ITEM2"],
    [1306, "ACT_MP_ATTACK_AIRWALK_ITEM2"],
    [1307, "ACT_MP_ATTACK_STAND_HARD_ITEM2"],
    [1308, "ACT_MP_ATTACK_CROUCH_HARD_ITEM2"],
    [1309, "ACT_MP_ATTACK_SWIM_HARD_ITEM2"],
    [1310, "ACT_MP_DEPLOYED_ITEM2"],
    [1311, "ACT_MP_DEPLOYED_IDLE_ITEM2"],
    [1312, "ACT_MP_CROUCHWALK_DEPLOYED_ITEM2"],
    [1313, "ACT_MP_CROUCH_DEPLOYED_IDLE_ITEM2"],
    [1314, "ACT_MP_ATTACK_STAND_PRIMARY_DEPLOYED_ITEM2"],
    [1315, "ACT_MP_ATTACK_CROUCH_PRIMARY_DEPLOYED_ITEM2"],
    [1316, "ACT_MP_RELOAD_STAND_ITEM2"],
    [1317, "ACT_MP_RELOAD_STAND_ITEM2_LOOP"],
    [1318, "ACT_MP_RELOAD_STAND_ITEM2_END"],
    [1319, "ACT_MP_RELOAD_CROUCH_ITEM2"],
    [1320, "ACT_MP_RELOAD_CROUCH_ITEM2_LOOP"],
    [1321, "ACT_MP_RELOAD_CROUCH_ITEM2_END"],
    [1322, "ACT_MP_RELOAD_SWIM_ITEM2"],
    [1323, "ACT_MP_RELOAD_SWIM_ITEM2_LOOP"],
    [1324, "ACT_MP_RELOAD_SWIM_ITEM2_END"],
    [1325, "ACT_MP_RELOAD_AIRWALK_ITEM2"],
    [1326, "ACT_MP_RELOAD_AIRWALK_ITEM2_LOOP"],
    [1327, "ACT_MP_RELOAD_AIRWALK_ITEM2_END"],
    [1328, "ACT_MP_RELOAD_NO_AMMO_ITEM2"],
    [1329, "ACT_MP_ATTACK_STAND_GRENADE_ITEM2"],
    [1330, "ACT_MP_ATTACK_CROUCH_GRENADE_ITEM2"],
    [1331, "ACT_MP_ATTACK_SWIM_GRENADE_ITEM2"],
    [1332, "ACT_MP_ATTACK_AIRWALK_GRENADE_ITEM2"],
    [1333, "ACT_MP_STAND_ITEM3"],
    [1334, "ACT_MP_CROUCH_ITEM3"],
    [1335, "ACT_MP_RUN_ITEM3"],
    [1336, "ACT_MP_WALK_ITEM3"],
    [1337, "ACT_MP_AIRWALK_ITEM3"],
    [1338, "ACT_MP_CROUCHWALK_ITEM3"],
    [1339, "ACT_MP_JUMP_ITEM3"],
    [1340, "ACT_MP_JUMP_START_ITEM3"],
    [1341, "ACT_MP_JUMP_FLOAT_ITEM3"],
    [1342, "ACT_MP_JUMP_LAND_ITEM3"],
    [1343, "ACT_MP_SWIM_ITEM3"],
    [1344, "ACT_MP_ATTACK_STAND_ITEM3"],
    [1345, "ACT_MP_ATTACK_STAND_ITEM3_SECONDARY"],
    [1346, "ACT_MP_ATTACK_CROUCH_ITEM3"],
    [1347, "ACT_MP_ATTACK_CROUCH_ITEM3_SECONDARY"],
    [1348, "ACT_MP_ATTACK_SWIM_ITEM3"],
    [1349, "ACT_MP_ATTACK_AIRWALK_ITEM3"],
    [1350, "ACT_MP_DEPLOYED_ITEM3"],
    [1351, "ACT_MP_DEPLOYED_IDLE_ITEM3"],
    [1352, "ACT_MP_CROUCHWALK_DEPLOYED_ITEM3"],
    [1353, "ACT_MP_CROUCH_DEPLOYED_IDLE_ITEM3"],
    [1354, "ACT_MP_ATTACK_STAND_PRIMARY_DEPLOYED_ITEM3"],
    [1355, "ACT_MP_ATTACK_CROUCH_PRIMARY_DEPLOYED_ITEM3"],
    [1356, "ACT_MP_STAND_ITEM4"],
    [1357, "ACT_MP_CROUCH_ITEM4"],
    [1358, "ACT_MP_RUN_ITEM4"],
    [1359, "ACT_MP_WALK_ITEM4"],
    [1360, "ACT_MP_AIRWALK_ITEM4"],
    [1361, "ACT_MP_CROUCHWALK_ITEM4"],
    [1362, "ACT_MP_JUMP_ITEM4"],
    [1363, "ACT_MP_JUMP_START_ITEM4"],
    [1364, "ACT_MP_JUMP_FLOAT_ITEM4"],
    [1365, "ACT_MP_JUMP_LAND_ITEM4"],
    [1366, "ACT_MP_SWIM_ITEM4"],
    [1367, "ACT_MP_ATTACK_STAND_ITEM4"],
    [1368, "ACT_MP_ATTACK_STAND_ITEM4_SECONDARY"],
    [1369, "ACT_MP_ATTACK_CROUCH_ITEM4"],
    [1370, "ACT_MP_ATTACK_CROUCH_ITEM4_SECONDARY"],
    [1371, "ACT_MP_ATTACK_SWIM_ITEM4"],
    [1372, "ACT_MP_ATTACK_AIRWALK_ITEM4"],
    [1373, "ACT_MP_DEPLOYED_ITEM4"],
    [1374, "ACT_MP_DEPLOYED_IDLE_ITEM4"],
    [1375, "ACT_MP_CROUCHWALK_DEPLOYED_ITEM4"],
    [1376, "ACT_MP_CROUCH_DEPLOYED_IDLE_ITEM4"],
    [1377, "ACT_MP_ATTACK_STAND_PRIMARY_DEPLOYED_ITEM4"],
    [1378, "ACT_MP_ATTACK_CROUCH_PRIMARY_DEPLOYED_ITEM4"],
    [1379, "ACT_MP_STAND_PASSTIME"],
    [1380, "ACT_MP_RUN_PASSTIME"],
    [1381, "ACT_MP_CROUCHWALK_PASSTIME"],
    [1382, "ACT_MP_GESTURE_FLINCH"],
    [1383, "ACT_MP_GESTURE_FLINCH_PRIMARY"],
    [1384, "ACT_MP_GESTURE_FLINCH_SECONDARY"],
    [1385, "ACT_MP_GESTURE_FLINCH_MELEE"],
    [1386, "ACT_MP_GESTURE_FLINCH_ITEM1"],
    [1387, "ACT_MP_GESTURE_FLINCH_ITEM2"],
    [1388, "ACT_MP_GESTURE_FLINCH_HEAD"],
    [1389, "ACT_MP_GESTURE_FLINCH_CHEST"],
    [1390, "ACT_MP_GESTURE_FLINCH_STOMACH"],
    [1391, "ACT_MP_GESTURE_FLINCH_LEFTARM"],
    [1392, "ACT_MP_GESTURE_FLINCH_RIGHTARM"],
    [1393, "ACT_MP_GESTURE_FLINCH_LEFTLEG"],
    [1394, "ACT_MP_GESTURE_FLINCH_RIGHTLEG"],
    [1395, "ACT_MP_GRENADE1_DRAW"],
    [1396, "ACT_MP_GRENADE1_IDLE"],
    [1397, "ACT_MP_GRENADE1_ATTACK"],
    [1398, "ACT_MP_GRENADE2_DRAW"],
    [1399, "ACT_MP_GRENADE2_IDLE"],
    [1400, "ACT_MP_GRENADE2_ATTACK"],
    [1401, "ACT_MP_PRIMARY_GRENADE1_DRAW"],
    [1402, "ACT_MP_PRIMARY_GRENADE1_IDLE"],
    [1403, "ACT_MP_PRIMARY_GRENADE1_ATTACK"],
    [1404, "ACT_MP_PRIMARY_GRENADE2_DRAW"],
    [1405, "ACT_MP_PRIMARY_GRENADE2_IDLE"],
    [1406, "ACT_MP_PRIMARY_GRENADE2_ATTACK"],
    [1407, "ACT_MP_SECONDARY_GRENADE1_DRAW"],
    [1408, "ACT_MP_SECONDARY_GRENADE1_IDLE"],
    [1409, "ACT_MP_SECONDARY_GRENADE1_ATTACK"],
    [1410, "ACT_MP_SECONDARY_GRENADE2_DRAW"],
    [1411, "ACT_MP_SECONDARY_GRENADE2_IDLE"],
    [1412, "ACT_MP_SECONDARY_GRENADE2_ATTACK"],
    [1413, "ACT_MP_MELEE_GRENADE1_DRAW"],
    [1414, "ACT_MP_MELEE_GRENADE1_IDLE"],
    [1415, "ACT_MP_MELEE_GRENADE1_ATTACK"],
    [1416, "ACT_MP_MELEE_GRENADE2_DRAW"],
    [1417, "ACT_MP_MELEE_GRENADE2_IDLE"],
    [1418, "ACT_MP_MELEE_GRENADE2_ATTACK"],
    [1419, "ACT_MP_ITEM1_GRENADE1_DRAW"],
    [1420, "ACT_MP_ITEM1_GRENADE1_IDLE"],
    [1421, "ACT_MP_ITEM1_GRENADE1_ATTACK"],
    [1422, "ACT_MP_ITEM1_GRENADE2_DRAW"],
    [1423, "ACT_MP_ITEM1_GRENADE2_IDLE"],
    [1424, "ACT_MP_ITEM1_GRENADE2_ATTACK"],
    [1425, "ACT_MP_ITEM2_GRENADE1_DRAW"],
    [1426, "ACT_MP_ITEM2_GRENADE1_IDLE"],
    [1427, "ACT_MP_ITEM2_GRENADE1_ATTACK"],
    [1428, "ACT_MP_ITEM2_GRENADE2_DRAW"],
    [1429, "ACT_MP_ITEM2_GRENADE2_IDLE"],
    [1430, "ACT_MP_ITEM2_GRENADE2_ATTACK"],
    [1431, "ACT_MP_STAND_BUILDING"],
    [1432, "ACT_MP_CROUCH_BUILDING"],
    [1433, "ACT_MP_RUN_BUILDING"],
    [1434, "ACT_MP_WALK_BUILDING"],
    [1435, "ACT_MP_AIRWALK_BUILDING"],
    [1436, "ACT_MP_CROUCHWALK_BUILDING"],
    [1437, "ACT_MP_JUMP_BUILDING"],
    [1438, "ACT_MP_JUMP_START_BUILDING"],
    [1439, "ACT_MP_JUMP_FLOAT_BUILDING"],
    [1440, "ACT_MP_JUMP_LAND_BUILDING"],
    [1441, "ACT_MP_SWIM_BUILDING"],
    [1442, "ACT_MP_ATTACK_STAND_BUILDING"],
    [1443, "ACT_MP_ATTACK_CROUCH_BUILDING"],
    [1444, "ACT_MP_ATTACK_SWIM_BUILDING"],
    [1445, "ACT_MP_ATTACK_AIRWALK_BUILDING"],
    [1446, "ACT_MP_ATTACK_STAND_GRENADE_BUILDING"],
    [1447, "ACT_MP_ATTACK_CROUCH_GRENADE_BUILDING"],
    [1448, "ACT_MP_ATTACK_SWIM_GRENADE_BUILDING"],
    [1449, "ACT_MP_ATTACK_AIRWALK_GRENADE_BUILDING"],
    [1450, "ACT_MP_STAND_BUILDING_DEPLOYED"],
    [1451, "ACT_MP_CROUCH_BUILDING_DEPLOYED"],
    [1452, "ACT_MP_RUN_BUILDING_DEPLOYED"],
    [1453, "ACT_MP_WALK_BUILDING_DEPLOYED"],
    [1454, "ACT_MP_AIRWALK_BUILDING_DEPLOYED"],
    [1455, "ACT_MP_CROUCHWALK_BUILDING_DEPLOYED"],
    [1456, "ACT_MP_JUMP_BUILDING_DEPLOYED"],
    [1457, "ACT_MP_JUMP_START_BUILDING_DEPLOYED"],
    [1458, "ACT_MP_JUMP_FLOAT_BUILDING_DEPLOYED"],
    [1459, "ACT_MP_JUMP_LAND_BUILDING_DEPLOYED"],
    [1460, "ACT_MP_SWIM_BUILDING_DEPLOYED"],
    [1461, "ACT_MP_ATTACK_STAND_BUILDING_DEPLOYED"],
    [1462, "ACT_MP_ATTACK_CROUCH_BUILDING_DEPLOYED"],
    [1463, "ACT_MP_ATTACK_SWIM_BUILDING_DEPLOYED"],
    [1464, "ACT_MP_ATTACK_AIRWALK_BUILDING_DEPLOYED"],
    [1465, "ACT_MP_ATTACK_STAND_GRENADE_BUILDING_DEPLOYED"],
    [1466, "ACT_MP_ATTACK_CROUCH_GRENADE_BUILDING_DEPLOYED"],
    [1467, "ACT_MP_ATTACK_SWIM_GRENADE_BUILDING_DEPLOYED"],
    [1468, "ACT_MP_ATTACK_AIRWALK_GRENADE_BUILDING_DEPLOYED"],
    [1469, "ACT_MP_STAND_PDA"],
    [1470, "ACT_MP_CROUCH_PDA"],
    [1471, "ACT_MP_RUN_PDA"],
    [1472, "ACT_MP_WALK_PDA"],
    [1473, "ACT_MP_AIRWALK_PDA"],
    [1474, "ACT_MP_CROUCHWALK_PDA"],
    [1475, "ACT_MP_JUMP_PDA"],
    [1476, "ACT_MP_JUMP_START_PDA"],
    [1477, "ACT_MP_JUMP_FLOAT_PDA"],
    [1478, "ACT_MP_JUMP_LAND_PDA"],
    [1479, "ACT_MP_SWIM_PDA"],
    [1480, "ACT_MP_ATTACK_STAND_PDA"],
    [1481, "ACT_MP_ATTACK_SWIM_PDA"],
    [1482, "ACT_MP_STAND_LOSERSTATE"],
    [1483, "ACT_MP_CROUCH_LOSERSTATE"],
    [1484, "ACT_MP_RUN_LOSERSTATE"],
    [1485, "ACT_MP_WALK_LOSERSTATE"],
    [1486, "ACT_MP_AIRWALK_LOSERSTATE"],
    [1487, "ACT_MP_CROUCHWALK_LOSERSTATE"],
    [1488, "ACT_MP_JUMP_LOSERSTATE"],
    [1489, "ACT_MP_JUMP_START_LOSERSTATE"],
    [1490, "ACT_MP_JUMP_FLOAT_LOSERSTATE"],
    [1491, "ACT_MP_JUMP_LAND_LOSERSTATE"],
    [1492, "ACT_MP_SWIM_LOSERSTATE"],
    [1493, "ACT_MP_DOUBLEJUMP_LOSERSTATE"],
    [1494, "ACT_MP_DOUBLEJUMP_CROUCH"],
    [1495, "ACT_MP_DOUBLEJUMP_CROUCH_PRIMARY"],
    [1496, "ACT_MP_DOUBLEJUMP_CROUCH_SECONDARY"],
    [1497, "ACT_MP_DOUBLEJUMP_CROUCH_MELEE"],
    [1498, "ACT_MP_DOUBLEJUMP_CROUCH_ITEM1"],
    [1499, "ACT_MP_DOUBLEJUMP_CROUCH_ITEM2"],
    [1500, "ACT_MP_DOUBLEJUMP_CROUCH_LOSERSTATE"],
    [1501, "ACT_MP_DOUBLEJUMP_CROUCH_PASSTIME"],
    [1502, "ACT_MP_GESTURE_VC_HANDMOUTH"],
    [1503, "ACT_MP_GESTURE_VC_FINGERPOINT"],
    [1504, "ACT_MP_GESTURE_VC_FISTPUMP"],
    [1505, "ACT_MP_GESTURE_VC_THUMBSUP"],
    [1506, "ACT_MP_GESTURE_VC_NODYES"],
    [1507, "ACT_MP_GESTURE_VC_NODNO"],
    [1508, "ACT_MP_GESTURE_VC_HANDMOUTH_PRIMARY"],
    [1509, "ACT_MP_GESTURE_VC_FINGERPOINT_PRIMARY"],
    [1510, "ACT_MP_GESTURE_VC_FISTPUMP_PRIMARY"],
    [1511, "ACT_MP_GESTURE_VC_THUMBSUP_PRIMARY"],
    [1512, "ACT_MP_GESTURE_VC_NODYES_PRIMARY"],
    [1513, "ACT_MP_GESTURE_VC_NODNO_PRIMARY"],
    [1514, "ACT_MP_GESTURE_VC_HANDMOUTH_SECONDARY"],
    [1515, "ACT_MP_GESTURE_VC_FINGERPOINT_SECONDARY"],
    [1516, "ACT_MP_GESTURE_VC_FISTPUMP_SECONDARY"],
    [1517, "ACT_MP_GESTURE_VC_THUMBSUP_SECONDARY"],
    [1518, "ACT_MP_GESTURE_VC_NODYES_SECONDARY"],
    [1519, "ACT_MP_GESTURE_VC_NODNO_SECONDARY"],
    [1520, "ACT_MP_GESTURE_VC_HANDMOUTH_MELEE"],
    [1521, "ACT_MP_GESTURE_VC_FINGERPOINT_MELEE"],
    [1522, "ACT_MP_GESTURE_VC_FISTPUMP_MELEE"],
    [1523, "ACT_MP_GESTURE_VC_THUMBSUP_MELEE"],
    [1524, "ACT_MP_GESTURE_VC_NODYES_MELEE"],
    [1525, "ACT_MP_GESTURE_VC_NODNO_MELEE"],
    [1526, "ACT_MP_GESTURE_VC_HANDMOUTH_ITEM1"],
    [1527, "ACT_MP_GESTURE_VC_FINGERPOINT_ITEM1"],
    [1528, "ACT_MP_GESTURE_VC_FISTPUMP_ITEM1"],
    [1529, "ACT_MP_GESTURE_VC_THUMBSUP_ITEM1"],
    [1530, "ACT_MP_GESTURE_VC_NODYES_ITEM1"],
    [1531, "ACT_MP_GESTURE_VC_NODNO_ITEM1"],
    [1532, "ACT_MP_GESTURE_VC_HANDMOUTH_ITEM2"],
    [1533, "ACT_MP_GESTURE_VC_FINGERPOINT_ITEM2"],
    [1534, "ACT_MP_GESTURE_VC_FISTPUMP_ITEM2"],
    [1535, "ACT_MP_GESTURE_VC_THUMBSUP_ITEM2"],
    [1536, "ACT_MP_GESTURE_VC_NODYES_ITEM2"],
    [1537, "ACT_MP_GESTURE_VC_NODNO_ITEM2"],
    [1538, "ACT_MP_GESTURE_VC_HANDMOUTH_BUILDING"],
    [1539, "ACT_MP_GESTURE_VC_FINGERPOINT_BUILDING"],
    [1540, "ACT_MP_GESTURE_VC_FISTPUMP_BUILDING"],
    [1541, "ACT_MP_GESTURE_VC_THUMBSUP_BUILDING"],
    [1542, "ACT_MP_GESTURE_VC_NODYES_BUILDING"],
    [1543, "ACT_MP_GESTURE_VC_NODNO_BUILDING"],
    [1544, "ACT_MP_GESTURE_VC_HANDMOUTH_PDA"],
    [1545, "ACT_MP_GESTURE_VC_FINGERPOINT_PDA"],
    [1546, "ACT_MP_GESTURE_VC_FISTPUMP_PDA"],
    [1547, "ACT_MP_GESTURE_VC_THUMBSUP_PDA"],
    [1548, "ACT_MP_GESTURE_VC_NODYES_PDA"],
    [1549, "ACT_MP_GESTURE_VC_NODNO_PDA"],
    [1550, "ACT_MP_STUN_BEGIN"],
    [1551, "ACT_MP_STUN_MIDDLE"],
    [1552, "ACT_MP_STUN_END"],
    [1553, "ACT_MP_PASSTIME_THROW_BEGIN"],
    [1554, "ACT_MP_PASSTIME_THROW_MIDDLE"],
    [1555, "ACT_MP_PASSTIME_THROW_END"],
    [1769, "ACT_MP_STAND_MELEE_ALLCLASS"],
    [1770, "ACT_MP_CROUCH_MELEE_ALLCLASS"],
    [1771, "ACT_MP_RUN_MELEE_ALLCLASS"],
    [1772, "ACT_MP_WALK_MELEE_ALLCLASS"],
    [1773, "ACT_MP_AIRWALK_MELEE_ALLCLASS"],
    [1774, "ACT_MP_CROUCHWALK_MELEE_ALLCLASS"],
    [1775, "ACT_MP_JUMP_MELEE_ALLCLASS"],
    [1776, "ACT_MP_JUMP_START_MELEE_ALLCLASS"],
    [1777, "ACT_MP_JUMP_FLOAT_MELEE_ALLCLASS"],
    [1778, "ACT_MP_JUMP_LAND_MELEE_ALLCLASS"],
    [1779, "ACT_MP_SWIM_MELEE_ALLCLASS"],
    [1780, "ACT_MP_ATTACK_STAND_MELEE_ALLCLASS"],
    [1781, "ACT_MP_ATTACK_STAND_MELEE_SECONDARY_ALLCLASS"],
    [1782, "ACT_MP_ATTACK_CROUCH_MELEE_ALLCLASS"],
    [1783, "ACT_MP_ATTACK_CROUCH_MELEE_SECONDARY_ALLCLASS"],
    [1784, "ACT_MP_ATTACK_SWIM_MELEE_ALLCLASS"],
    [1785, "ACT_MP_ATTACK_AIRWALK_MELEE_ALLCLASS"],
    [1800, "ACT_MP_STAND_BOMB"],
    [1801, "ACT_MP_JUMP_START_BOMB"],
    [1802, "ACT_MP_JUMP_FLOAT_BOMB"],
    [1803, "ACT_MP_JUMP_LAND_BOMB"],
    [1804, "ACT_MP_RUN_BOMB"],
    [1805, "ACT_MP_SWIM_BOMB"],
    [1813, "ACT_MP_RELOAD_STAND_PRIMARY3"],
    [1814, "ACT_MP_RELOAD_CROUCH_PRIMARY3"],
    [1815, "ACT_MP_RELOAD_AIRWALK_PRIMARY3"],
    [1816, "ACT_MP_RELOAD_STAND_PRIMARY3_LOOP"],
    [1817, "ACT_MP_RELOAD_CROUCH_PRIMARY3_LOOP"],
    [1818, "ACT_MP_RELOAD_AIRWALK_PRIMARY3_LOOP"],
    [1819, "ACT_MP_RELOAD_STAND_PRIMARY3_END"],
    [1820, "ACT_MP_RELOAD_CROUCH_PRIMARY3_END"],
    [1821, "ACT_MP_RELOAD_AIRWALK_PRIMARY3_END"],
    [1822, "ACT_MP_RELOAD_SWIM_PRIMARY3"],
    [1823, "ACT_MP_THROW"],
    [1890, "ACT_MP_COMPETITIVE_LOSERSTATE"],
    [1891, "ACT_MP_COMPETITIVE_WINNERSTATE"],
    [1893, "ACT_MP_PUSH_STAND_SECONDARY"],
    [1894, "ACT_MP_PUSH_CROUCH_SECONDARY"],
    [1895, "ACT_MP_PUSH_SWIM_SECONDARY"],
    [1897, "ACT_MP_FALLING_STOMP"],
    [1898, "ACT_MP_FALLING_STOMP_PRIMARY"],
    [1899, "ACT_MP_FALLING_STOMP_MELEE"],
    [1944, "ACT_MP_CYOA_PDA_INTRO"],
    [1945, "ACT_MP_CYOA_PDA_IDLE"],
    [1946, "ACT_MP_CYOA_PDA_OUTRO"],
]);
